import { requestMs } from "@helpers/api";

export const invoices = {
  getInvoiceDetails: (invoiceId) => requestMs.get(`/api3/invoice/${ invoiceId }`, {}),
  getInvoicePDF: ({invoiceId}) => requestMs.get(`/api3/invoice/${ invoiceId }/pdf`, {}),
  getInvoices: ({ userId, search, filter, page,  dateFrom, dateTo, filterContractId, filterReservationId }) => requestMs.get(`api3/user/${userId}/invoice?page=${page}${filter}${search}${dateFrom}${dateTo}${filterContractId}${filterReservationId}`),
  markInvoiceRead: ({invoiceId}) => requestMs.put(`/api3/invoice/${ invoiceId }/read`, {})
};
